import type { SuggestionItem } from "@digdir/designsystemet-react";
import { z } from "zod";
import type { VarmeSelskapDto } from "@/api/generated";

const selskapId = z.string();
const valgtLeverandoer = z.object({
  label: z.string(),
  value: selskapId,
});
export type LeverandoerSelected2 = z.infer<typeof valgtLeverandoer> | undefined;
export type LeverandoerSelected = SuggestionItem;

const finnLeverandoerFormBaseSchema = z.object({
  leverandoer: valgtLeverandoer.optional(),
  harEgenLøsning: z.array(selskapId),
});

type FinnLeverandoerFormBaseValues = z.infer<
  typeof finnLeverandoerFormBaseSchema
>;

export const finnLeverandoerFormSchema = finnLeverandoerFormBaseSchema
  .refine((data) => data.leverandoer !== undefined, {
    path: ["leverandoer"],
    message: "pages.finn-leverandoer.form.leverandoer.paaakrevd",
  })
  .refine((data) => !leverandoerHarEgenLøsning(data), {
    path: ["harEgenLøsning"],
    message: "pages.finn-leverandoer.form.leverandoer.har-egen-løsning",
  });

export type finnLeverandoerFormValues = z.infer<
  typeof finnLeverandoerFormSchema
>;

export function getDefaultLeverandoerFormValues(
  leverandoerer: VarmeSelskapDto[] | undefined,
  valgtLeverandoer?: LeverandoerSelected,
): finnLeverandoerFormValues {
  return {
    leverandoer: valgtLeverandoer,
    harEgenLøsning: finnLeverandoererMedEgenLøsning(leverandoerer),
  };
}

function finnLeverandoererMedEgenLøsning(
  leverandoerer: VarmeSelskapDto[] | undefined,
): string[] {
  return (leverandoerer || [])
    .filter((l) => l.harEgenLøsning)
    .map((l) => l.organisasjonsnummer);
}

function leverandoerHarEgenLøsning(
  data: FinnLeverandoerFormBaseValues,
): boolean {
  const harEgen =
    (data.leverandoer?.value &&
      data.harEgenLøsning.includes(data.leverandoer?.value)) ||
    false;
  return harEgen;
}
